// import React, { useEffect, useState } from "react";
// import { classNames } from "../../helpers/classNames";

// const Tabs = ({
//   tabs,
//   tabContainerClass,
//   tabNavClass,
//   tabButtonClass,
//   tabButtonActiveClass,
//   tabContentClass,
//   setSelected = () => {},
//   ...props
// }) => {
//   const [selectedTab, setSelectedTab] = useState({});

//   const handleTabSelection = (tab = {}) => {
//     setSelectedTab(tab); // updates local UI immediately
//     setSelected(tab._id); // not delayed, parent gets notified
//   };

//   useEffect(() => {
//     if (tabs.length) {
//       setSelectedTab(tabs[0]);
//       setSelected(tabs[0]._id); // tell parent what's selected
//     }
//   }, [tabs]);

//   return (
//     <>
//       <div
//         className={classNames(
//           "relative flex flex-col items-start",
//           tabContainerClass
//         )}
//       >
//         <nav
//           className={classNames(
//             "flex overflow-auto gap-2 max-w-full",
//             tabNavClass
//           )}
//         >
//           {tabs.map((item, index) => (
//             <button
//               type="button"
//               className={classNames(
//                 "relative rounded-t-2xl transition-all duration-200 px-4 h-12 whitespace-nowrap text-base font-medium",
//                 tabButtonClass,
//                 item._id === selectedTab?._id
//                   ? classNames(
//                       "bg-chestnut-rose text-white",
//                       tabButtonActiveClass
//                     )
//                   : "bg-shades-04 text-gable-green"
//               )}
//               key={index}
//               onClick={() => handleTabSelection(item)}
//             >
//               {item.name}
//             </button>
//           ))}
//         </nav>
//         <div
//           className={classNames(
//             "relative rounded-2xl !rounded-tl-none bg-white py-4",
//             tabContentClass
//           )}
//         >
//           {selectedTab?.component}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Tabs;
import { useState } from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { motion, AnimatePresence } from "framer-motion";
import { classNames } from "../../helpers/classNames";
import Scrollbars from "react-custom-scrollbars-2";

const Tabs = ({
  defaultActiveKey,
  items = [],
  selectedIndex,
  setSelectedIndex = () => {},
  content = true,
  tabsClass,
}) => {
  const [selectedTab, setSelectedTab] = useState(defaultActiveKey || 0);

  return (
    <TabGroup
      {...(typeof selectedIndex === "number"
        ? {
            selectedIndex: selectedIndex,
            onChange: (index) => {
              setSelectedIndex(index);
              setSelectedTab(index); // Update internal state for underline
            },
          }
        : {
            defaultIndex: defaultActiveKey,
            onChange: setSelectedTab,
          })}
      className={"h-full"}
    >
      <Scrollbars autoHide className="!h-10">
        <TabList className={classNames("flex", tabsClass)}>
          {items &&
            Array.isArray(items) &&
            items?.map((tab, i) => (
              <Tab
                disabled={tab?.disabled || false}
                key={i?.toString()}
                className={classNames(
                  "relative border-b-2 border-gray-300 pb-3 px-6 text-sm font-medium",
                  i === selectedTab ? "text-chestnut-rose" : "text-gray-500",
                  tab?.disabled ? "opacity-50 cursor-not-allowed" : ""
                )}
              >
                <div className="flex gap-2 items-center">
                  {tab?.icon && (
                    <span>
                      <i className={classNames("fa-fw", tab?.icon)}></i>
                    </span>
                  )}
                  <span className="whitespace-nowrap">{tab?.label}</span>
                </div>
                {i === selectedTab ? (
                  <motion.div
                    className="h-[2px] bg-chestnut-rose w-full absolute left-0 -bottom-[1.6px]"
                    layoutId="underline"
                    id="underline"
                  />
                ) : null}
              </Tab>
            ))}
        </TabList>
      </Scrollbars>
      {content && (
        <TabPanels className={"mt-5 h-[calc(100%-90px)]"}>
          {items &&
            Array.isArray(items) &&
            items?.map((tab, i) => (
              <TabPanel key={i?.toString()} className={"h-full"}>
                {tab?.content}
              </TabPanel>
            ))}
        </TabPanels>
      )}
    </TabGroup>
  );
};

export default Tabs;
